import {
  optional,
  string,
  boolean,
  number,
  integer,
  record,
  unknown,
  intersection,
  type,
  type Infer,
  object,
  array,
  enums,
} from 'superstruct';

/**
 * Note: This schema object has to be maintained and updated
 * to stay strictly aligned with the backend server config schema
 * in order to maintain the appropriate config validation.
 */
export const knownServerConfigSchema = type({
  'config_core_tenant-id': optional(string()),
  'config_observability_sentry-dsn': optional(string()),
  'config_observability_sentry-max-breadcrumbs': optional(integer()),
  'config_observability_sentry-errors-sample-rate': optional(number()),
  'config_observability_sentry-traces-sample-rate': optional(number()),
  'config_observability_custom-view-tracing': optional(boolean()),
  config_observability_enabled: optional(boolean()),
  'config_analytics_segment-key': optional(string()),
  config_analytics_retry_max_attempts: optional(integer()),
  release_analytics_enable_segment: optional(boolean()),
  config_analytics_cache_max_events: optional(integer()),
  config_analytics_batch_size: optional(integer()),
  config_analytics_batch_interval_ms: optional(integer()),
  release_analytics_transport: optional(enums(['websocket', 'rest'])),
  'config_core-web': optional(
    object({
      mobileAppUrls: optional(
        object({
          appStoreUrl: optional(string()),
          playStoreUrl: optional(string()),
        }),
      ),
    }),
  ),

  // About Me
  'config_about-me_health-report-masonry-id': optional(string()),
  'flag_about-me_show-account-banner': optional(boolean()),
  'flag_about-me_show-options-menu': optional(boolean()),
  'flag_about-me_show-landing-page-back-button': optional(boolean()),
  release_about_me_masonry_2_for_metric_details: optional(boolean()),

  // Health Profile
  'flag_health-profile_ratings-bar-enabled': optional(boolean()),
  'flag_health-profile_care-sdk-enabled': optional(boolean()),
  'flag_health-profile_chat-with-professional-enabled': optional(boolean()),

  // Journey Configuration
  config_about_me_care_library: optional(boolean()),
  config_journey_disable_delight_overlay: optional(boolean()),
  config_journey_hide_last_page_trailing_button_label_on_mobile: optional(
    boolean(),
  ),
  flag_journey_enable_masonry_1_5_for_activities: optional(boolean()),
  release_journey_experience_masonry_2_for_activities: optional(boolean()),
  release_journey_experience_masonry_2_for_campaign_overview: optional(
    boolean(),
  ),
  config_journey_experience_remove_header: optional(boolean()),

  // User Profile
  'flag_user-profile_fetch-on-auth-embedded': optional(boolean()),

  // Supported Locales
  'config_locales_supported-locales': optional(array(string())),
  'config_locales_default-locale': optional(string()),
});

export type KnownServerConfig = Infer<typeof knownServerConfigSchema>;

export const unknownServerConfigSchema = record(string(), unknown());

export type UnknownServerConfig = Infer<typeof unknownServerConfigSchema>;

export const serverConfigSchema = intersection([
  knownServerConfigSchema,
  unknownServerConfigSchema,
]);

export type ServerConfig = Infer<typeof serverConfigSchema>;
